import { render, staticRenderFns } from "./idlePublishAfter.vue?vue&type=template&id=31ba98cf&"
import script from "./idlePublishAfter.vue?vue&type=script&lang=js&"
export * from "./idlePublishAfter.vue?vue&type=script&lang=js&"
import style0 from "./idlePublishAfter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports